import { render } from "./TriageDashboardPage.vue?vue&type=template&id=ec977c72"
import script from "./TriageDashboardPage.vue?vue&type=script&lang=js"
export * from "./TriageDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__